import { Directive, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { I18nComponent } from '@app/core/i18n/components/i18n.component';

@Directive({
  selector: '[vcOpenI18nPopin]'
})
export class OpenI18nPopinDirective {
  constructor(public modal: MatDialog) {}

  @HostListener('click', ['$event'])
  openPopinAlert() {
    this.modal.open(I18nComponent, {
      width: '600px',
      maxWidth: '100vw'
    });
  }
}
